// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__163tz","card":"Cards_card__2HhSU","infected":"Cards_infected__2vsau","recovered":"Cards_recovered__1iVxp","deaths":"Cards_deaths__2-JIl"};